import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-reset-mob',
  templateUrl: './reset-mob.component.html',
  styleUrls: ['./reset-mob.component.css']
})
export class ResetMobComponent implements OnInit {
  message: string;
  constructor(private sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        this.sharedService.setHeaderTitle('home_msite');
        this.activatedRoute.params.subscribe((params: Params) => {
            if (params['mobile'] !== undefined) {
                // sharedService.resetUser(params['mobile'])
                // .then(res => {
                //     if (res.status === 'success') {
                //         this.message = res.message;
                //     }else {
                //         this.message = res.message;
                //     }
                // });
            }
          });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reset-mob/reset-mob.component.ts